import noData from "../../Media/SVG/no_data.svg";

export default function EmptyState({ message = "موردی برای نمایش وجود ندارد", compact = false, className = "" }) {
  return (
    <div className={`w-full flex justify-center items-center flex-col ${compact ? "gap-2 py-3" : "gap-5 py-5"} ${className}`}>
      <p className="text-center text-zi-text-light dark:text-zi-text-dark">{message}</p>
      {!compact && <img src={noData} alt="" aria-hidden="true" className="w-24" />}
    </div>
  );
}
